import { useEffect } from 'react';
import { META_PIXEL_READY_EVENT } from '@/lib/analytics/metaPixel/constants';
import { isMetaPixelEnabled } from '@/lib/analytics/metaPixel/client';
import { metaPixelSetUserData, normalizeMetaCity } from '@/lib/analytics/metaPixel/metaPixelEvent';
import { useMetaPixelEnabled } from '@/lib/analytics/metaPixel/useMetaPixelEnabled';
import { useAuthState } from '../context/AuthContext';

const MetaPixelUpdater = () => {
  const { user, isLoggedIn } = useAuthState();
  const metaPixelEnabled = useMetaPixelEnabled();

  useEffect(() => {
    if (!metaPixelEnabled || typeof window === 'undefined' || !isLoggedIn || !user) {
      return;
    }

    const updateMetaPixelUser = () => {
      if (!isMetaPixelEnabled()) {
        return;
      }

      metaPixelSetUserData({
        ...(user.email && { em: user.email }),
        ...(user.phoneNumber && { ph: user.phoneNumber }),
        ...(user.firstName && { fn: user.firstName }),
        ...(user.surname && { ln: user.surname }),
        ...(user.city?.menuTitle && { ct: normalizeMetaCity(user.city.menuTitle) }),
        ...(user.id && { external_id: String(user.id) }),
      });
    };

    updateMetaPixelUser();
    if (window.fbq) {
      return;
    }

    window.addEventListener(META_PIXEL_READY_EVENT, updateMetaPixelUser);
    return () => window.removeEventListener(META_PIXEL_READY_EVENT, updateMetaPixelUser);
  }, [metaPixelEnabled, isLoggedIn, user]);

  return null;
};

export default MetaPixelUpdater;
